<div
  *ngFor="let item of _items"
  class="subMenuContainer"
  [class.kLeft]="position === 'left'"
  [class.kRight]="position === 'right'"
  [class.active]="item === _selectedMenuItem"
>
  <a [class.activeLink]="item === _selectedMenuItem" (click)="item.open()"> {{ item.menuTitle | uppercase }}</a>
  <div class="linkMarker"></div>
</div>
